import { FMEDownloadTypes } from '@shared/export-types';
import {
  ExportFormats,
  ExportConfigurations,
  ExportTypes,
  ExportVeiligGravenContent,
} from '../../interfaces/export-types.enum';

export interface AppStateModel {
  // mapMode: MapMode;
  klicViewMode: 'table' | 'list' | 'map';
  showEvNotification: boolean;
  googleAdsConsent: boolean;
  openConsentWindow: boolean;
  exportConfiguration: {
    selectedDownloadType: {
      format: ExportFormats;
      url: FMEDownloadTypes;
      fileType: string;
      mail: boolean;
      exportConfigurations: (typeof ExportConfigurations)[];
    };
    selectedDownloadConfiguration: string;
    selectedDownloadFilters: string[];
    selectedExportType?: ExportTypes;
    selectedVeiligGravenContent?: ExportVeiligGravenContent;
  };
  orderScreenLayers: {
    activeKLICmeldingen: boolean;
    archivedKLICmeldingen: boolean;
  };
  /** Slug of the featured news item the user closed last. Missing in app state stored before it existed. */
  lastReadFeaturedNews?: string;
}

export class SetExportConfiguration {
  static readonly type = '[App] Set Export Configuration';
  constructor(
    public payload: {
      exportConfiguration: {
        selectedDownloadType: {
          format: ExportFormats;
          url: FMEDownloadTypes;
          fileType: string;
          mail: boolean;
          exportConfigurations: (typeof ExportConfigurations)[];
        };
        selectedDownloadConfiguration: string;
        selectedDownloadFilters: string[];
        selectedExportType?: ExportTypes;
        selectedVeiligGravenContent?: ExportVeiligGravenContent;
      };
    }
  ) {}
}

export class SetKlicViewMode {
  static readonly type = '[App] Set Klic View Mode';
  constructor(public payload: { klicViewMode: 'table' | 'list' | 'map' }) {}
}

export class SetShowEvNotification {
  static readonly type = '[App] Set Show EV Notification';
  constructor(public payload: { showEvNotification: boolean }) {}
}

export class SetGoogleAdsConsent {
  static readonly type = '[App] SetGoogleAdsConsent';
  constructor(
    public payload: {
      adConsentGiven: boolean;
    }
  ) {}
}

export class UpdateOrderScreenLayers {
  static readonly type = '[App] UpdateOrderScreenLayers';
  constructor(public payload: { activeKLICmeldingen: boolean; archivedKLICmeldingen: boolean }) {}
}

export class MarkFeaturedNewsRead {
  static readonly type = '[App] MarkFeaturedNewsRead';
  constructor(public payload: { slug: string }) {}
}
